import { useParams } from "react-router-dom";
import { ProductOfferingConfigsPageView } from "src/routes/libraries/product-offering-configs/ProductOfferingConfigsPage";
import { ProjectParams } from "src/routes/routesDef";

export function ProjectProductOfferingConfigsPage() {
  const { projectId, productOfferingId } = useParams<ProjectParams & { productOfferingId: string }>();
  return <ProductOfferingConfigsPageView marketsOrIds={{ projectId, productOfferingId }} />;
}
